import React, { useState, useEffect } from 'react';
import { usersAPI, meetAPI } from '../../services/api';
import './TeacherPages.css';

const Students = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [bookingForm, setBookingForm] = useState({
    scheduledAt: '',
    durationMinutes: 60,
    title: ''
  });

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await usersAPI.getStudents();
      setStudents(response.data.students);
    } catch (error) {
      console.error('Students fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleScheduleLesson = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    try {
      await meetAPI.createLesson({
        studentId: selectedStudent.id,
        scheduledAt: bookingForm.scheduledAt,
        durationMinutes: parseInt(bookingForm.durationMinutes),
        title: bookingForm.title || `Japanese Lesson with ${selectedStudent.name}`
      });
      alert('Lesson scheduled successfully!\nレッスンが予約されました！');
      setShowModal(false);
      setBookingForm({ scheduledAt: '', durationMinutes: 60, title: '' });
    } catch (error) {
      alert('Failed to schedule lesson: ' + error.message);
    }
  };

  if (loading) {
    return (
      <div className="flex-center" style={{ height: '50vh' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="students-page fade-in">
      <h1>👥 Student Management</h1>
      <p className="page-subtitle">生徒管理 - Manage your students</p>

      <div className="students-table">
        <table>
          <thead>
            <tr>
              <th>Student / 生徒</th>
              <th>Email</th>
              <th>Level</th>
              <th>Lessons</th>
              <th>Joined</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student) => (
              <tr key={student.id}>
                <td>
                  <div className="student-cell">
                    <div className="student-avatar">
                      {student.profile_picture ? (
                        <img src={student.profile_picture} alt="" />
                      ) : (
                        <span>{student.name?.charAt(0)}</span>
                      )}
                    </div>
                    <div>
                      <strong>{student.name}</strong>
                      {student.name_japanese && (
                        <span style={{ display: 'block', fontSize: '12px', color: 'var(--color-text-light)' }}>
                          {student.name_japanese}
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td>{student.email}</td>
                <td>
                  <span className={`level-badge level-${student.japanese_level?.toLowerCase()}`}>
                    {student.japanese_level || 'N5'}
                  </span>
                </td>
                <td>{student.total_lessons_taken || 0}</td>
                <td>
                  {new Date(student.created_at).toLocaleDateString('ja-JP')}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => handleScheduleLesson(student)}
                    >
                      📅 Schedule
                    </button>
                    <button className="btn btn-outline btn-sm">
                      View
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {students.length === 0 && (
        <div className="empty-state" style={{ marginTop: '24px' }}>
          <p>No students yet</p>
          <p className="text-muted">まだ生徒がいません</p>
        </div>
      )}

      {/* 予約モーダル */}
      {showModal && (
        <div className="booking-modal" onClick={() => setShowModal(false)}>
          <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>📅 Schedule Lesson / レッスンを予約</h2>
            <p style={{ marginBottom: '20px', color: 'var(--color-text-light)' }}>
              Schedule a lesson with {selectedStudent?.name}
            </p>
            
            <form onSubmit={handleBookingSubmit}>
              <div className="form-group">
                <label className="form-label">Date & Time / 日時</label>
                <input
                  type="datetime-local"
                  className="form-input"
                  value={bookingForm.scheduledAt}
                  onChange={(e) => setBookingForm({ ...bookingForm, scheduledAt: e.target.value })}
                  required
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Duration / 時間</label>
                <select
                  className="form-select"
                  value={bookingForm.durationMinutes}
                  onChange={(e) => setBookingForm({ ...bookingForm, durationMinutes: e.target.value })}
                >
                  <option value="30">30 minutes</option>
                  <option value="60">60 minutes</option>
                  <option value="90">90 minutes</option>
                  <option value="120">120 minutes</option>
                </select>
              </div>
              
              <div className="form-group">
                <label className="form-label">Lesson Title / レッスンタイトル (Optional)</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="e.g., N5 Grammar Review"
                  value={bookingForm.title}
                  onChange={(e) => setBookingForm({ ...bookingForm, title: e.target.value })}
                />
              </div>
              
              <div className="modal-actions">
                <button 
                  type="button" 
                  className="btn btn-outline"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  📹 Create with Google Meet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Students;
